import { horizontalEllipsis } from '@ipfabric/frontend-shared-assets/utils/characters';
import { useLocale } from 'containers/App/LocaleContext';
import type { ReactNode } from 'react';

const MAX_VISIBLE_LENGTH = 20;

export const getSnapshotOptionTitle = (
  name: string,
  isCanceled: boolean,
): ReactNode => {
  const { snapshotWithoutName } = useLocale().generic.components.snapshotsList;
  const trimmed = name.trim();
  const displayName = trimmed || snapshotWithoutName;
  const title = isCanceled ? `(Canceled) ${displayName}` : displayName;
  if (typeof title === 'string' && title.length > MAX_VISIBLE_LENGTH) {
    return `${title.substring(0, MAX_VISIBLE_LENGTH)}${horizontalEllipsis}`;
  }
  return title;
};
